/* @flow */
import {
  RECEIVE_FOUNDRY_RESPONSE,
  RECEIVE_BAD_FOUNDRY_RESPONSE
} from '../actions/foundry_response';
import type { Action } from '../actions/types';
import {toLower} from 'lodash';

export default (state: AnalyticsState = {}, action: Action): AnalyticsState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      const {
        data: {
          page_data: {
            channels,
            page_type,
            type_id,
            object_id,
            reporting_category,
            result_count,
            search_term,
            url_full
          } = {},
          ad_data: {
            ad_sponsor: sponsor
          } = {}
        } = {}
      } = action;

      return {
        ...state,
        channels,
        page_type: toLower(page_type),
        type_id,
        object_id,
        reporting_category,
        result_count,
        search_term,
        sponsor,
        url_full
      };
    case RECEIVE_BAD_FOUNDRY_RESPONSE:
      return {
        ...state,
        result_count: 0
      };
    default:
      return state;
  }
};

type AnalyticsState = {
  page_type?: string,
  type_id?: number,
  object_id?: number,
  url_full?: string,
  reporting_category?: string,
  result_count?: number,
  search_term?: string,
  sponsor?: string
};
